import { EntityTypes } from './enums/entityTypes';

export interface CapitalRequest {
  requestId: string;
  orgId: string;
  userId: string;
  entityType: EntityTypes.capitalRequest;
  capitalTypes: string[];
  capitalNeed: number;
  capitalNeedList: CapitalNeed[];
  SGPProvided: boolean;
  growthPlans: File[];
  financialStatements: {
    year: number;
    file: File;
  }[];
  positiveEBITDA: boolean;
  EBITDARange: CapitalRange;
  questions?: {
    [key: string]: string;
  };
  draft: boolean;
  status: string;
  created: number;
  lastUpdated: number;
}

export interface File {
  fileName: string;
  s3Key: string;
}
export interface CapitalRange {
  min: number;
  max: number;
  unknown: boolean;
  unprovided: boolean;
}

export interface CapitalNeed {
  description: string;
  amount: number;
}

export interface CapitalRequestItem extends Omit<CapitalRequest, 'requestId'> {
  PK: string;
  requestId?: string;
}

export interface CapitalRequestInput {
  capitalTypes: string[];
  capitalNeed: number;
  capitalNeedList: CapitalNeed[];
  SGPProvided: boolean;
  growthPlans: File[];
  financialStatements: { year: number; file: File }[];
  positiveEBITDA: boolean;
  EBITDARange: CapitalRange;
  questions: string[];
}
